export class UserFormTemplate {
  userId!: number;
  formTemplateId!: number;
  formTemplateTypeId!: number;
  projectId!: number;
  id!: number;
}
